import ARIA, { ARIAElement } from "../utils/ARIA";

export default class ARIAText extends Phaser.GameObjects.Text {
	private aria?: ARIAElement;

	setARIA(layer?: string, focus = false): void {
		if (this.aria) {
			this.aria.setText(this.text);
			if (focus) this.aria.focus();
		} else this.aria = ARIA.addText(this, layer, focus);
	}

	removeARIA(): void {
		if (this.aria) ARIA.removeElement(this.aria);
	}

	showARIA(): void {
		this.aria?.show();
	}

	hideARIA(): void {
		this.aria?.hide();
	}

	showARIALayer(layer?: string, hideRest = false): void {
		ARIA.showLayer(layer, hideRest);
	}

	hideLayer(layer?: string): void {
		ARIA.hideLayer(layer);
	}

	blurARIA(): void {
		this.aria?.blur();
	}

	focusARIA(): void {
		this.aria?.focus();
	}

	// Update ARIA when Text updates
	setText(text: string): this {
		super.setText(text);
		if (this.aria) {
			this.aria.setText(text);
		}
		this.emit("textUpdated", this.text, this);
		return this;
	}
}
